import { CommonModule } from '@angular/common';
import { Component, Input, input } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Conversation } from 'src/app/dashboard/conversations/panels/conversation.model';
import { FileUploadModalComponent } from 'src/app/dashboard/main/accountant/modals/file-upload-modal.component';


@Component({
    selector: 'app-easy-upload',
    imports: [CommonModule],
    templateUrl: './easy-upload.component.html',
    styleUrl: './easy-upload.component.scss'
})
export class EasyUploadComponent {

  bsModalRef: BsModalRef;
  bsFileUploadModalRef: BsModalRef;
  @Input() conversation: Conversation;

  currentFolder: any = [];

  constructor(
    private modalService: BsModalService,
  ) {}

  public openModalFileUpload() {
    console.log("THE UUID", this.conversation);
    this.bsFileUploadModalRef = this.modalService.show(
      FileUploadModalComponent,
      {
        initialState: {
          currentConversationID: this.conversation.id,
          targetFolder: 'easy-upload',
          staff: false, // Should this be true or false?
        },
      },
    );
  }
}
